/**
 * components.js
 *
 * @version 1.0.0
 */

import { initDialogs } from './dialog.js';
import { initDrawers } from './drawer.js';
import { initAccordions } from './accordion.js';
import { initQuantities } from './quantity.js';
import { initCollectionFilters } from './collectionFilters.js';
import { initMenus } from './menu.js';
import { initCartDrawer } from './cartDrawer.js';

document.addEventListener('DOMContentLoaded', () => {
	initDialogs();
	initDrawers();
	initAccordions();
	initQuantities();
	initCollectionFilters();
	initMenus();
	initCartDrawer();
});
